<div>
  <ag-grid-angular
    #locationGroupsGrid
    [rowData]="locationGroups()"
    [columnDefs]="locationGroupColumns"
    [gridOptions]="tableDef"
    [loading]="isLoading()"
    class="w-full"
  ></ag-grid-angular>
</div>

<app-pan-modal #createNewLocationGroup [topLevel]="false" data-testid="create-location-group-modal" (modalClose)="clearModalProps()">
  <div header>Create New Location Group</div>

  <div body class="flex flex-col gap-2">
    <app-pan-form-control>
      <app-pan-floating-label>Location Group Name</app-pan-floating-label>
      <input
        type="text"
        panInput
        [(ngModel)]="newLocationGroupName"
        placeholder="Enter location group name..."
        data-testid="create-location-group-name-input"
      />
    </app-pan-form-control>

    <label class="flex gap-2" class="text-sm">
      <input
        #checkbox
        type="checkbox"
        panCheckbox
        [(ngModel)]="newLocationGroupIsNational"
        data-testid="create-location-group-is-national-input"
      />
      Is this a national location group?
    </label>
  </div>

  <div footer class="flex gap-2">
    <button panButton panModalClose data-testid="create-location-group-cancel">Cancel</button>

    @if (editingLocationGroup()) {
      <button
        panButton
        color="primary"
        (click)="updateLocationGroup()"
        [disabled]="!canCreateLocationGroup()"
        data-testid="update-location-group-submit"
      >
        Update Location Group
      </button>
    } @else {
      <button
        panButton
        color="primary"
        (click)="createLocationGroup()"
        [disabled]="!canCreateLocationGroup()"
        data-testid="create-location-group-submit"
      >
        Create Location Group
      </button>
    }
  </div>
</app-pan-modal>
